export default "__VITE_ASSET__8G3kwCoZ__"